import { useMemo } from 'react';

import { useSkuForecastDataQuery } from 'src/services/api/getSkuForecastData';
import forecastService from 'src/services/forecast/forecastService';
import { useBoundStore } from 'src/store/store';
import type { ForecastDataPoint } from 'src/types/domain/ForecastDataPoint';

export const useForecast = (sku: string) => {
  const { data: queryData, isLoading, error } = useSkuForecastDataQuery(sku);
  const { forecastData } = useBoundStore((state) => state);

  const sortPerDate = (a: ForecastDataPoint, b: ForecastDataPoint) => {
    if (a.year !== b.year) return a.year - b.year;
    return a.month - b.month;
  };

  const data = useMemo(() => {
    if (!queryData) return [];

    const storeData = forecastData[forecastService.getStoreKey(sku)];
    if (storeData) {
      return storeData.sort(sortPerDate);
    }

    return queryData.sort(sortPerDate);
  }, [queryData, forecastData, sku, sortPerDate]);

  return {
    data,
    isLoading,
    error,
  };
};
